import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("beekeep_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 402 → upgrade modal. Subscribers register via onUsageLimitHit().
const usageLimitListeners = new Set();
export function onUsageLimitHit(fn) {
  usageLimitListeners.add(fn);
  return () => usageLimitListeners.delete(fn);
}
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const d = err.response.data?.detail;
      // detail is the dict we emit from enforce_usage_limit()
      if (d && typeof d === "object" && d.code === "usage_limit_reached") {
        usageLimitListeners.forEach((fn) => { try { fn(d); } catch { /* swallow */ } });
        // Replace the structured detail with the human message so existing
        // `toast.error(err.response.data.detail)` call sites don't try to
        // render an object as a React child.
        err.response.data.detail = d.message;
        err.usageLimit = d;
      }
    }

    // FastAPI / Pydantic 422 → `detail` is an array of {loc, msg, ...} objects.
    // Sonner can't render those, so legacy `toast.error(err.response.data.detail
    // || "Save failed")` collapses to the fallback string. Flatten into a
    // readable single string so the real field-level error surfaces everywhere.
    const d = err?.response?.data?.detail;
    if (Array.isArray(d)) {
      err.response.data.detail = d
        .map((e) => {
          const field = Array.isArray(e?.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
          return field ? `${field}: ${e.msg}` : e?.msg || JSON.stringify(e);
        })
        .join("; ");
    } else if (d && typeof d === "object" && !Array.isArray(d) && typeof d.message === "string") {
      // Some Pro-gate / yard-cap responses use {code, message, ...}; surface message.
      err.response.data.detail = d.message;
    }

    return Promise.reject(err);
  },
);

export default api;
